import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LocalizationService } from './localization.service';
import { map } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./localization.service";
var ProfessionService = /** @class */ (function () {
    function ProfessionService(http, baseUrl, localizationService) {
        this.http = http;
        this.baseUrl = baseUrl;
        this.localizationService = localizationService;
        this.apiUrl = this.baseUrl + "api/professions";
    }
    ProfessionService.prototype.getProfessions = function () {
        var _this = this;
        return new Observable(function (subscriber) {
            _this.getProfessionsCall(subscriber);
            _this.localizationService.addLangSubscriber(subscriber, function (obs) { return _this.getProfessionsCall(obs); });
        });
    };
    ProfessionService.prototype.getProfessionsCall = function (subscriber) {
        var code = this.localizationService.getLocale();
        if (ProfessionService.cache[code]) {
            subscriber.next(ProfessionService.cache[code]);
            return;
        }
        this.http
            .get("" + this.apiUrl)
            .pipe(map(function (professions) {
            // Sort by a - z, but make sure 'notCandidate' is always the last item in the list.
            var notCandidate = professions.find(function (p) { return p.type === 'NotCandidate'; });
            professions = professions.filter(function (p) { return p != notCandidate; });
            professions = professions.sort(function (a, b) { return a.label.localeCompare(b.label, 'fr'); }); // localCompare() is used so that 'É' is sorted properly. English doesn't have non-ASCII chars, so it can safely be sorted with the FR locale.
            return professions.concat([notCandidate]);
        }))
            .subscribe(function (professions) {
            ProfessionService.cache[code] = professions;
            subscriber.next(professions);
        }, function (error) { return subscriber.error(error); });
    };
    ProfessionService.cache = {};
    ProfessionService.ngInjectableDef = i0.defineInjectable({ factory: function ProfessionService_Factory() { return new ProfessionService(i0.inject(i1.HttpClient), i0.inject("BASE_URL"), i0.inject(i2.LocalizationService)); }, token: ProfessionService, providedIn: "root" });
    return ProfessionService;
}());
export { ProfessionService };
